
const Items =  [
  {
    'kode': 'E14160071',
    'penjual': 'CV Mitra Sejahtera',
    'pembeli': 'Unit Usaha Kayu Bremen Semarang',
    'tanggalBerlaku': '21-03-2019',
    'komoditas': 'Kayu sengon',
    'musim': '18/19',

    'harga': '200000',
    'kuantitas': '100',
    'unitKuantitas': 'm3',
    'dibuatPada': '28-12-2018',
    'status': "Sedang diproses",
    'tempatPembayaran': {
      'street': 'Unit Usaha Kayu Bremen Semarang',
    }
  },
  {
    'kode': 'G84150073',
    'penjual': 'CV Rimba Lestari',
    'pembeli': 'PT Sumber Pangan',
    'tanggalBerlaku': '04-12-2018',
    'komoditas': 'Jambu kristal',
    'musim': '18/19',

    'harga': '200000',
    'kuantitas': '4',
    'unitKuantitas': 'ton',
    'dibuatPada': '05-01-2019',
    'status': "Tersampaikan",
    'tempatPembayaran': {
      'street': 'Transfer ATM',
    },
  },
  {
    'kode': 'A24260056',
    'penjual': 'CV Tani Prima',
    'pembeli': 'Unit Pasar Ani Sukoharjo',
    'tanggalBerlaku': '24-05-2018',
    'komoditas': 'Cabai rawit',
    'musim': '17/18',

    'harga': '200000',
    'kuantitas': '140',
    'unitKuantitas': 'Kg',
    'dibuatPada': '06-10-2018',
    'status': "Belum konfirmasi",
    'tempatPembayaran': {
      'street': 'Unit Pasar Ani Sukoharjo',
    },
  },
  {
    'kode': 'F24150004',
    'penjual': 'PT Laju Pasar Rimba',
    'pembeli': 'CV Tani Prima',
    'tanggalBerlaku': '12-09-2018',
    'komoditas': 'Kayu jabon',
    'musim': '18/19',

    'harga': '200000',
    'kuantitas': '300',
    'unitKuantitas': 'm3',
    'dibuatPada': '30-11-2018',
    'status': "Konfirmasi",
    'tempatPembayaran': {
      'street': 'Transfer ATM',
    },
  },
  {
    'kode': 'H14160065',
    'penjual': 'CV Sukasari',
    'pembeli': 'Unit Gergaji Kayu Berkah Leuwiliang',
    'tanggalBerlaku': '15-03-2019',
    'komoditas': 'Kayu sengon',
    'musim': '18/19',

    'harga': '200000',
    'kuantitas': '400',
    'unitKuantitas': 'm3',
    'dibuatPada': '06-02-2019',
    'status': "Sedang diproses",
    'tempatPembayaran': {
      'street': 'CV Sukasari',
    },
  },
  {
    'kode': 'G64150076',
    'penjual': 'PT Vera Sylva Kencana',
    'pembeli': 'PT Arena Hutan Lestari',
    'tanggalBerlaku': '06-11-2018',
    'komoditas': 'Kayu sengon',
    'musim': '18/19',

    'harga': '200000',
    'kuantitas': '200',
    'unitKuantitas': 'm3',
    'dibuatPada': '04-12-2018',
    'status': "Tersampaikan",
    'tempatPembayaran': {
      'street': 'Transfer ATM',
    },
  },
  {
    'kode': 'C34170098',
    'penjual': 'CV Rindang Tretep',
    'pembeli': 'Unit Industri Kopi Kapal Api',
    'tanggalBerlaku': '15-09-2018',
    'komoditas': 'Kopi',
    'musim': '18/19',

    'harga': '200000',
    'kuantitas': '500',
    'unitKuantitas': 'Kg',
    'dibuatPada': '23-02-2019',
    'status': "Konfirmasi",
    'tempatPembayaran': {
      'street': 'Unit Industri Kopi Kapal Api',
    },
  },
  {
    'kode': 'I24160002',
    'penjual': 'CV Sultan Muda',
    'pembeli': 'PT Jagawana Jaya',
    'tanggalBerlaku': '09-01-2019',
    'komoditas': 'Kayu jabon',
    'musim': '18/19',

    'harga': '200000',
    'kuantitas': '250',
    'unitKuantitas': 'm3',
    'dibuatPada': '25-03-2019',
    'status': "Belum konfirmasi",
    'tempatPembayaran': {
      'street': 'CV Sultan Muda',
    },
  },
  {
    'kode': 'D24170034',
    'penjual': 'PT Agro Wiseso',
    'pembeli': 'PT Sukawening Asih',
    'tanggalBerlaku': '22-06-2018 ',
    'komoditas': 'Kapulaga',
    'musim': '17/18',

    'harga': '200000',
    'kuantitas': '300',
    'unitKuantitas': 'Kg',
    'dibuatPada': '03-02-2019',
    'status': "Ditunda",
    'tempatPembayaran': {
      'street': 'Transfer ATM',
    },
  },
  {
    'kode': localStorage.kontrakID,
    'penjual': localStorage.kontrakPenjual,
    'pembeli': localStorage.kontrakPembeli,
    'tanggalBerlaku': localStorage.kontrakActiveCurrentDate,
    'komoditas': localStorage.kontrakKomoditas,
    'musim': localStorage.kontrakMusim,

    'harga': localStorage.kontrakHarga,
    'kuantitas': localStorage.kontrakKuantitas,
    'unitKuantitas': localStorage.kontrakUnitKuantitas,
    'dibuatPada': localStorage.kontrakActiveCurrentDate,
    'status': localStorage.komoditasStatus,
    'tempatPembayaran': {
      'street': localStorage.kontrakTempatPembayaran,
    }
  },
];

const getKontrakById = (kode) => {
  return (kode === undefined) ? Items[0] : Items.find(x => x.kode === kode);
};

const getKontrak = (limit) => {
  return (limit) ? Items.slice(0, limit) : Items;
};

export {
  Items,
  getKontrak,
  getKontrakById
};